import { BaseModal } from '@/lib/Modals';
import { ConnectorFlowInstanceDTO } from '@/models/connectors';
import { camelCaseToTitleCase } from '@/utils/words';
import { FC } from 'react';

type ConnectorFlowInstanceDetailsModalProps = {
  flowInstance: ConnectorFlowInstanceDTO;
  closeModal: VoidFunction;
};

export const ConnectorFlowInstanceDetailsModal: FC<ConnectorFlowInstanceDetailsModalProps> = ({ flowInstance, closeModal }) => {
  const renderSection = (title: string, data: Record<string, any>) => {
    const entries = Object.entries(data);
    if (entries.length === 0) {
      return null;
    }

    return (
      <div className='space-y-2'>
        <h3 className='text-sm font-semibold text-gray-900'>{title}</h3>
        <div className='space-y-1.5'>
          {entries.map(([key, value]) => (
            <div key={key} className='flex flex-col'>
              <span className='text-xs font-medium text-gray-500'>{camelCaseToTitleCase(key)}</span>
              <span className='text-sm text-gray-900'>{typeof value === 'boolean' ? (value ? 'Yes' : 'No') : String(value)}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <BaseModal onClose={closeModal} classNames={{ dialog: 'max-w-2xl', content: 'min-w-[32rem]' }}>
      <div className='flex flex-col gap-4'>
        <div className='flex flex-col gap-1'>
          <h2 className='text-xl font-semibold text-gray-900'>Connector Details</h2>
          <p className='text-sm text-gray-600'>{flowInstance.connectorName}</p>
        </div>

        <div className='flex flex-col gap-4 max-h-96 overflow-y-auto'>
          {renderSection('Parameters', flowInstance.params)}
          {renderSection('Mappings', flowInstance.mappings)}
        </div>

        <div className='flex justify-end pt-2 border-t border-gray-200'>
          <button
            onClick={closeModal}
            className='px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'
          >
            Close
          </button>
        </div>
      </div>
    </BaseModal>
  );
};
